import { Button, cn } from "@tellescope/ui";
import { ReactNode } from "react";
import { Link } from "react-router-dom";

export interface CreateEventHeaderButtonProps {
  children: ReactNode;
  onClick: (() => void) | { to: string; replace?: boolean };
}

export const CreateEventHeaderButton = ({ children, onClick }: CreateEventHeaderButtonProps) => {
  const className = cn("text-lg text-muted-foreground px-0");

  if (typeof onClick === "object") {
    return (
      <Button variant="link" asChild className={className}>
        <Link to={onClick.to} replace={onClick.replace}>
          {children}
        </Link>
      </Button>
    );
  }

  return (
    <Button onClick={onClick} variant="link" className={className}>
      {children}
    </Button>
  );
};
